import { render } from "./form.vue?vue&type=template&id=23a19ef1&scoped=true&ts=true"
import script from "./form.vue?vue&type=script&lang=ts"
export * from "./form.vue?vue&type=script&lang=ts"

import "./form.vue?vue&type=style&index=0&id=23a19ef1&scoped=true&lang=less"

import exportComponent from "/home/runner/work/vue3-admin/vue3-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a19ef1"]])

export default __exports__